import React, { useState, useCallback } from 'react';
import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';
import { cn } from '../../../lib/utils';

// Hook de ordenamiento de tablas (genérico, no atado a ningún edificio).
// El orden NO se persiste: arranca siempre en el default (key === null).
export function useTableSort() {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const requestSort = useCallback((key) => {
    setSortConfig((prev) => {
      if (prev.key !== key) return { key, direction: 'asc' };
      if (prev.direction === 'asc') return { key, direction: 'desc' };
      // 3er click → vuelve al orden por defecto (por Unidades)
      return { key: null, direction: 'asc' };
    });
  }, []);
  return { sortConfig, requestSort };
}

// Comparador genérico. Acepta strings (localeCompare) o números.
export function compareValues(va, vb, direction) {
  const dir = direction === 'asc' ? 1 : -1;
  let cmp;
  if (typeof va === 'string' && typeof vb === 'string') {
    cmp = va.localeCompare(vb, 'es', { numeric: true, sensitivity: 'base' });
  } else {
    cmp = va < vb ? -1 : va > vb ? 1 : 0;
  }
  return cmp * dir;
}

// Encabezado clickeable con flecha indicadora de orden.
export function SortHeader({ label, sortKey, sortConfig, onSort, align = 'left', className }) {
  const active = sortConfig.key === sortKey;
  const Icon = !active ? ChevronsUpDown : sortConfig.direction === 'asc' ? ArrowUp : ArrowDown;
  return (
    <th className={className}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={cn(
          'inline-flex items-center gap-1 select-none cursor-pointer hover:text-slate-700 transition-colors uppercase tracking-wider font-semibold',
          align === 'right' && 'flex-row-reverse',
          align === 'center' && 'mx-auto',
          active ? 'text-slate-700' : 'text-slate-500'
        )}
        data-testid={`sort-header-${sortKey}`}
      >
        <span>{label}</span>
        <Icon className={cn('w-3 h-3 shrink-0', active ? 'text-slate-600' : 'text-slate-400')} />
      </button>
    </th>
  );
}
